/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

type Props = {
  className: string,
  title: string,
  data?:any
}

const TablesWidget15: React.FC<Props> = ({className,title,data}) => {
  
  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-bottom-0 px-0'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-3 mb-1'>{title}</span>
        </h3>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-0 px-0'>
        <div className='tab-content'>
          {/* begin::Tap pane */}
          <div className='tab-pane fade show active' id='kt_table_widget_4_tab_1'>
            {/* begin::Table container */}
            <div className='table-responsive'>
              {/* begin::Table */}
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-3'>
                {/* begin::Table head */}
                <thead>
                  <tr className='fw-bold rounded text-muted bg-light'>
                    {/* <th className='p-0 w-50px'></th> */}
                    <th className='ps-4 min-w-150px rounded-start'>Full Name</th>
                    <th className='min-w-150px'>Id Number</th>
                    <th className='min-w-150px'>Gender</th>
                    <th className='min-w-120px rounded-end'>Age</th>
                  </tr>
                </thead>
                {/* end::Table head */}
                {/* begin::Table body */}
                <tbody>
                  {
                    data && (

                      data.map((traveller:any,index:any) => {                        
                        return (
                          <tr key={index}>
                            <td className='text-start ps-3'>
                              <div className='text-dark fw-bold mb-1 fs-6'>
                                {traveller['firstName']+' '+traveller['lastName']}
                              </div>
                            </td>
                            <td className='text-start ps-3'>
                              <span className='text-dark fw-bold mb-1 fs-6'>{traveller['idNumber']}</span>
                            </td>
                            <td className='text-start ps-3'>
                              <span className='text-dark fw-bold mb-1 fs-6'>{traveller['gender']}</span>
                            </td>
                            <td className='text-start ps-3'>
                              <span className='text-dark fw-bold mb-1 fs-6'>{traveller['age']}</span>
                            </td>
                          </tr>
                        )
                      })
                    )
                  }
                </tbody>
                {/* end::Table body */}
              </table>
                {
                  data.length == 0 && (
                    <div className="row w-100">
                      <div className="col-lg-12">
                        <div className='text-gray-500 text-center fw-bold mb-1 fs-6'>No Record Found.</div>
                      </div>
                    </div>
                  )
                }
            </div>
            {/* end::Table */}
          </div>
          {/* end::Tap pane */}
        </div>
      </div>
      {/* end::Body */}
    </div>
  )
}

export {TablesWidget15}
